export enum BackfillStatusApiEnum {
    inProgress = 'IN_PROGRESS',
    completed = 'COMPLETED',
    standBy = 'STAND_BY',
    failed = 'FAILED'
}
